<template>
  <div v-resize="viewOptions" class="wh-100">
    <div ref="echartDom" style="height:100%;" v-show="!emptyBox"></div>
    <emptyBox v-if="emptyBox" />
  </div>
</template>

<script type="text/ecmascript-6">
import * as echarts from 'echarts'

export default {
  props: {
    timerOut: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      emptyBox: false,
      viewOptions: {
        immediate: true,
        handler: this.resize
        // mode: 'width'
      }
    }
  },
  mounted() {
    this.init()
    this.bindIntoView()
  },
  methods: {
    init() {
      const el = this.$refs.echartDom
      this.chart = echarts.init(el, null)
    },
    getChartObj() {
      return this.chart
    },
    update(option, map) {
      if(option === null) return this.setEmpty()
      this.chart.clear()
      this.emptyBox = false
      map && echarts.registerMap(map.name, map.geoJson)
      // option.
      this.chart.setOption(option)
    },
    setEmpty() {
      this.chart.clear()
      this.emptyBox = true
    },
    // 重置echarts图表
    resize(a) {
      if (this.timerResize) clearTimeout(this.timerResize)
      this.timerResize = setTimeout(() => {
        this.$nextTick(() => {
          this.chart && this.chart.resize()
        })
        this.timerResize = null
      }, this.timerOut)
    },
    // 解决隐藏状态重置导致图表大小异常的问题 不支持IE
    bindIntoView() {
      // Register IntersectionObserver
      const io = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio > 0) {
            this.resize()
          }
        })
      })
      const el = this.$el
      io.observe(el)
      this.io = io
    },
    unBindIntoView() {
      const el = this.$el
      this.io.unobserve(el)
      this.io = null
    }
  },
  beforeDestroy() {
    this.unBindIntoView()
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-table-emptyImg .empty {
  margin-top: 30px;
  margin-bottom: 20px;
}
</style>
